module.exports = __webpack_public_path__ + "img/img29.c9d91e4d.svg";